module.exports = __webpack_public_path__ + "static/NeuzeitGro-Bol-cc838a38e9efd829ff705bee1ea5c772.woff";